import { CALL_API } from '../middleware/ApiMiddleware';

export const PRODUCT_LAYOUT_FETCH_REQUEST = 'PRODUCT_LAYOUT_FETCH_REQUEST';
export const PRODUCT_LAYOUT_FETCH_SUCCESS = 'PRODUCT_LAYOUT_FETCH_SUCCESS';
export const PRODUCT_LAYOUT_FETCH_FAILURE = 'PRODUCT_LAYOUT_FETCH_FAILURE';

export const PRODUCT_LAYOUT_EDIT_SEQUENCE_REQUEST = 'PRODUCT_LAYOUT_EDIT_SEQUENCE_REQUEST';
export const PRODUCT_LAYOUT_EDIT_SEQUENCE_SUCCESS = 'PRODUCT_LAYOUT_EDIT_SEQUENCE_SUCCESS';
export const PRODUCT_LAYOUT_EDIT_SEQUENCE_FAILURE = 'PRODUCT_LAYOUT_EDIT_SEQUENCE_FAILURE';

export const SYSTEM_TILE_EDIT_REQUEST = 'SYSTEM_TILE_EDIT_REQUEST';
export const SYSTEM_TILE_EDIT_SUCCESS = 'SYSTEM_TILE_EDIT_SUCCESS';
export const SYSTEM_TILE_EDIT_FAILURE = 'SYSTEM_TILE_EDIT_FAILURE';

export const CLEAR_PRODUCT_LAYOUT = 'CLEAR_PRODUCT_LAYOUT';

const baseURL = 'config/layout';
const xerceConfigBaseURL = 'xerce/config/layout';

export const fetchProductLayout = (hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [PRODUCT_LAYOUT_FETCH_REQUEST, PRODUCT_LAYOUT_FETCH_SUCCESS, PRODUCT_LAYOUT_FETCH_FAILURE],
    hideLoadingWidget,
  },
});

export const editProductLayoutSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${xerceConfigBaseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [
      PRODUCT_LAYOUT_EDIT_SEQUENCE_REQUEST,
      PRODUCT_LAYOUT_EDIT_SEQUENCE_SUCCESS,
      PRODUCT_LAYOUT_EDIT_SEQUENCE_FAILURE,
    ],
  },
});

export const editCaseSystemTile = (systemTileId: number, label: string) => ({
  [CALL_API]: {
    endpoint: `${xerceConfigBaseURL}/${systemTileId}`,
    method: 'put',
    authenticated: true,
    body: { label },
    types: [SYSTEM_TILE_EDIT_REQUEST, SYSTEM_TILE_EDIT_SUCCESS, SYSTEM_TILE_EDIT_FAILURE],
  },
});

export const clearProductLayout = () => ({
  type: CLEAR_PRODUCT_LAYOUT,
});
